// PlanComponents/utils.js
// 共通ユーティリティ関数

/**
 * 円を「万円」表示へ変換するヘルパー
 * @param {number} amountYen - 金額（円）
 * @returns {string} 万円表示の文字列
 */
export function toManYenLabel(amountYen) {
  const man = Math.floor(amountYen / 10000);
  return `${man.toLocaleString()}万円`;
}

/**
 * 2つの日付の差を日数で返す
 * @param {string|Date} startDate - 開始日
 * @param {string|Date} endDate - 終了日
 * @returns {number} 日数差
 */
export function calcDays(startDate, endDate) {
  if (!startDate || !endDate) return 0;
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffMs = end.getTime() - start.getTime();
  return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
}

/**
 * 2つの日付の差を月数で返す（小数第1位まで）
 * @param {string|Date} startDate - 開始日
 * @param {string|Date} endDate - 終了日
 * @returns {number} 月数差
 */
export function calcMonths(startDate, endDate) {
  if (!startDate || !endDate) return 0;
  const start = new Date(startDate);
  const end = new Date(endDate);
  const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  const dayDiff = end.getDate() - start.getDate();
  return Math.max(0, parseFloat((months + dayDiff / 30).toFixed(1)));
}
